<template>
  <div class="col-12 col-lg-8 c">
    <div class="card">
        <div class="card-header">
            <h4>
                <i class="fa fa-edit"></i>
                عقد العمل
            </h4>
        </div>
        <div class="card-body">
            <div class="alert alert-danger text-center g" v-if="error">{{ error }}</div>
            <div class="alert alert-success text-center g" v-if="success"><h2 class="text-success">{{ success }}</h2></div>
            <template v-if="current._id">
                <div class="row">
                    <div class="col-12 col-lg-6 g">
                        <button class="btn btn-block btn-lg btn-success" @click="print()">
                            <i class="fa fa-print"></i>
                            طباعة العقد
                        </button>
                    </div>
                    <div class="col-12 col-lg-6 g" v-b-modal.signature>
                        <button class="btn btn-block btn-lg btn-info" @click="signatureStart()" style="background: #4DA1A9 !important; border: solid 1px #4DA1A9 !important">
                            <i class="fa fa-pencil"></i>
                            توقيع العقد
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <b-modal id="signature" title="توقيع العقد" hide-footer>
        <canvas v-if="!current.signature" id="theCanvas" style="width: 100%; height: 100px; border: solid 1px darkred"></canvas>
        <div class="col-12 text-center" v-if="!current.signature" >
            <button id="clearButton" class="btn btn-sm btn-outline-danger" style="margin: 5px">
                <i class="fa fa-times"></i>
                ازالة التوقيع</button>
            <button class="btn btn-success" @click="saveSignature()" style="margin: 5px">
                <i class="fa fa-check"></i>
                حفظ التوقيع</button>
        </div>
        <div v-if="current.signature" >تم حفظ التوقيع بنجاح</div>
        <hr>
        <img v-if="!current.signature"  :src="require('@/assets/images/signature.gif')" style="width: 100%">
    </b-modal>
  </div>
</template>

<script>
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        BDropdown,
        BDropdownItem,
        BModal
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            current: {},
            success: null,
            error: null
        }
    },
    created(){
        var g = this;
        $.post(api + '/admin/web/contract', {
            jwt: g.user.jwt
        }).then(function(r){
            if(r.status == 100){
                g.current = r.response;
            }else{
                g.error = r.response;
            }
        })
    },
    methods: {
        saveSignature(){
            var g = this;
            var content = document.getElementById("theCanvas").toDataURL();
            $.post(api + '/admin/web/save-signature', {
                jwt: g.user.jwt,
                content: content
            }).then(function(r){
                $("#signature___BV_modal_header_ > button").click()
                if(r.status == 100){
                    g.current.signature = content
                    g.error = null;
                    g.success = r.response
                }else{
                    g.success = null;
                    g.error = r.response;
                }
            })
        },
        signatureStart(){
            var g = this;
            setTimeout(function(){
                const MAIN_MOUSE_BUTTON = 0;

                function prepareContext(canvasElement) {
                let dpr = window.devicePixelRatio || 1;
                let rect = canvasElement.getBoundingClientRect();
                canvasElement.width = rect.width * dpr;
                canvasElement.height = rect.height * dpr;
                
                let context = canvasElement.getContext("2d");
                context.scale(dpr, dpr);
                
                return context;
                }

                function setLineProperties(context) {
                context.lineWidth = 2;
                context.lineJoin = "round";
                context.lineCap = "round";
                return context;
                }

                let clearButton = document.getElementById("clearButton");
                let theCanvas = document.getElementById("theCanvas");
                let theContext = prepareContext(theCanvas);
                let shouldDraw = false;

                theCanvas.addEventListener("mousedown", start);
                theCanvas.addEventListener("mouseup", end);
                theCanvas.addEventListener("mousemove", move, false);

                theCanvas.addEventListener("touchstart", tstart);
                theCanvas.addEventListener("touchend", tend);
                theCanvas.addEventListener("touchcancel", tend);
                theCanvas.addEventListener("touchmove", tmove, false);

                

                clearButton.addEventListener("click", event => {
                    clearCanvas(theContext);
                });

                
                function clearCanvas(context) {
                context.clearRect(0, 0, context.canvas.width, context.canvas.height);  
                }

                function start(event) {

                    event.preventDefault();
                    shouldDraw = true;
                    setLineProperties(theContext);

                    theContext.beginPath();
                    
                    let elementRect = event.target.getBoundingClientRect();
                    theContext.moveTo(event.clientX - elementRect.left, event.clientY - elementRect.top);
                }

                function end(event) {
                    event.preventDefault();
                    shouldDraw = false;
                }

                function move(event) {
                    event.preventDefault();
                if (shouldDraw) {
                    let elementRect = event.target.getBoundingClientRect();
                    theContext.lineTo(event.clientX - elementRect.left, event.clientY - elementRect.top);
                    theContext.stroke()
                }
                }

                function tstart(event) {

                    event.preventDefault();
                    shouldDraw = true;
                    setLineProperties(theContext);

                    theContext.beginPath();
                    
                    let elementRect = event.target.getBoundingClientRect();
                    theContext.moveTo(event.touches[0].clientX - elementRect.left, event.touches[0].clientY - elementRect.top);
                }

                function tend(event) {
                    event.preventDefault();
                    shouldDraw = false;
                }

                function tmove(event) {
                    event.preventDefault();
                if (shouldDraw) {
                    let elementRect = event.target.getBoundingClientRect();
                    theContext.lineTo(event.touches[0].clientX - elementRect.left, event.touches[0].clientY - elementRect.top);
                    theContext.stroke()
                }
                }
            }, 100)
        },
        print(){
            var g = this;
            var win = window.open("");
            if(typeof g.current.info != 'string'){
                g.current.info = JSON.stringify(g.current.info)
            }
            if(typeof g.current.content != 'string'){
                g.current.content = JSON.stringify(g.current.content)
            }
            g.header = JSON.parse(g.current.info).contract.header;
            g.body = JSON.parse(g.current.info).contract.body;
            g.footer = JSON.parse(g.current.info).contract.footer;
            g.current.content = JSON.parse(g.current.content);
            win.document.write(`
            <html dir='rtl'>
            <head>
                <style>
                @page {
                    size: A4;
                    margin: 0;
                }
                html, body {
                    margin: 0;
                    padding: 0;
                    background: #fff;
                }
                .page {
                    width: 210mm;
                    height: 297mm;
                    padding: 35mm 15mm 25mm 15mm;
                    box-sizing: border-box;
                    page-break-after: always;
                    background-image: url("/images/contract.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-position: top left;
                    position: relative;
                    overflow: hidden;
                }
                .page:last-child {
                    page-break-after: auto;
                }
                #source {
                    display: none;
                }
                h4 {
                    line-height: 1.8;
                }
                .page-break {
                    break-before: page;
                }
                </style>
            </head>
            <body>
                <div id='source'>
                  <div class='block' style='text-align: left;'><span>رقم العقد: ${g.current.id}</span></div>
                  <div class='block'><center><h2>عقد عمل موسمي لحج عام ١٤٤٧ هـ</h2></center></div>
                  <div class='block'><p>${g.replaceVariables(g.current, g.header.replaceAll("\n", "<br>"))}</p></div>
                  <div class='block'><p>السيد/ ${g.current.name}
                  &nbsp;&nbsp;
                  &nbsp;&nbsp;
                  &nbsp;&nbsp;
                  &nbsp;&nbsp;
                  الجنسية/ ${g.current.content.national}</p></div>
                  <div class='block'><p style='padding: 5px; border-top: 0.5px solid #ddd; border-bottom: 0.5px solid #ddd;'>
                    بموجب هوية رقم/ ${g.current.content.number}
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;
                    صادرة من/ ${g.current.content.number_source}
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;
                    وتاريخ الميلاد/ ${g.current.content.birth_date.replaceAll('-', '/')}
                  </p></div>
                  <div class='block'><p style='padding: 5px; padding-top: 0px; margin-top: -10px; border-bottom: 0.5px solid #ddd;'>
                    رقم الجوال/
                    &nbsp;&nbsp;
                    &nbsp;&nbsp;${g.current.phone}
                  </p></div>
                  ${g.replaceVariables(g.current, g.body.replaceAll("\n", "<br>")).split(/<br\s*\/?>/i).map(function(line){
                    return "<div class='block'><p>" + (line.trim() === '' ? '&nbsp;' : line) + "</p></div>";
                  }).join("")}
                  <div class='block force-new-page'>
                    <p>${g.replaceVariables(g.current, g.footer.replaceAll("\n", "<br>"))}</p>
                    <div style='display: inline-block; width: 49%'>
                      <p style='margin: 0px auto; text-align: center'>الطرف الأول</p>
                      <p style='margin: 0px auto; text-align: center'>عبدالله عبدالعزيز عبدالله الشلاش</p>
                      <p>التوقيع:</p>
                    </div>
                    <div style='display: inline-block; width: 49%'>
                      <p style='margin: 0px auto; text-align: center'>الطرف الثاني</p>
                      <p style='margin: 0px auto; text-align: center'>${g.current.name}</p>
                      <p>&nbsp;&nbsp;&nbsp;التوقيع: ${g.current.signature ? "<img width='250' src='"+g.current.signature+"'>" : ''}</p>
                    </div>
                  </div>
                </div>
                <div id='output'></div>
                <scr` + `ipt>
                  (function(){
                    function paginate(){
                      var source = document.getElementById('source');
                      var output = document.getElementById('output');
                      var blocks = Array.from(source.querySelectorAll(':scope > .block'));

                      function newPage(){
                        var p = document.createElement('div');
                        p.className = 'page';
                        output.appendChild(p);
                        return p;
                      }

                      var current = newPage();

                      blocks.forEach(function(block){
                        if(block.classList.contains('force-new-page') && current.children.length > 0){
                          current = newPage();
                        }
                        current.appendChild(block);
                        if(current.scrollHeight > current.clientHeight + 2 && current.children.length > 1){
                          current.removeChild(block);
                          current = newPage();
                          current.appendChild(block);
                        }
                      });

                      source.remove();
                    }
                    paginate();
                    setTimeout(function(){ window.print(); }, 500);
                  })();
                </scr` + `ipt>
            </body>
            </html>
            `)
            win.document.close()
        },
        replaceVariables(current, input){
            for(var i=0; i<=20; i++){
            input = input.replace( /{(.*?)}/, function (x) {
            x = x.replace('{', '').replace('}', '')
            if(x == 'job'){
                if(current.job['code']){
                    return current.job['title'];
                }
            }
            if(current[x]){
                return current[x];
            }
            if(typeof current.info == 'string'){
                current.info = JSON.parse(current.info)
            }
            if(typeof current.content == 'string'){
                current.content = JSON.parse(current.content)
            }
            if(typeof current.job == 'string'){
                current.job = JSON.parse(current.job)
            }
            if(current.info[x]){
                return current.info[x];
            }
            if(current.content[x]){
                return current.content[x];
            }
            if(current.job[x]){
                return current.job[x];
            }
            return `${x}`;
            } )
            }
            return input
        },
    }
}
</script>

<style>

</style>